import React from 'react'
import PrivatePageSF from '../../../templates/PrivatePageSF.js'
import PageTitleUI from '../../../widgets/output/PageTitleUI'
import MessageUtils from '../../../util/MessageUtils'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import RepaymentListUI from '../../../components/finapp/loan/RepaymentListUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'

const LoanListPageUI = ({context, messageList, loanList, repaymentList, loanCount, errorList, onRefreshClick}) =>
  <PrivatePageSF context={context} className='pg_loans'  backLink='/home'
                 messageList={messageList} headerMessageKey='c_loans'
                 centered={!loanList && !repaymentList && !errorList}
  >
    {
      !loanList && !repaymentList && !errorList &&
      <SpinnerComponentUI/>
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]}/>
    }
    {
      (loanList || repaymentList) &&
      <>
        <PageTitleUI context={context} messageList={messageList} titleMessageKey='c_loans'
          goBack={true} backLink='/home' />
        <LRTableActionsUI location='top'
          left={
            <IconButtonUI messageList={messageList} icon='icon-refresh' onClick={onRefreshClick} labelKey='c_refresh' />
          }
          right={<span />}
        />
      </>
    }
    {
      repaymentList && repaymentList.length !== 0 &&
      <RepaymentListUI context={context} repaymentList={repaymentList} loanCount={loanCount} />
    }

    {
      loanList && loanList.length !== 0 &&
      <span/>
    }

    {
      loanList && loanList.length === 0 &&
      // change this to Modal if loanList list is displayed in future
      <span>No loans yet</span>
    }
  </PrivatePageSF>

export default LoanListPageUI
